import React from 'react';
import useSWR from 'swr';
import { Role } from '../components/permission/form';
import { UserApi } from '../apis';

export const useRole = () => {
  const { data: me, isLoading } = useSWR('/api/user/me', UserApi.me);
  const [role, setRole] = React.useState<Record<string, Role>>({});

  React.useEffect(() => {
    if (me) {
      setRole(me?.permissions);

      console.log('me?.permissions :', me?.permissions);
    }
  }, [me]);

  const isEdit = (code: string) => {
    return me?.permissions?.[code]?.isUpdate;
  };

  const isView = (code: string) => {
    return me?.permissions?.[code]?.isCreate;
  };

  const isCreate = (code: string) => {
    return me?.permissions?.[code]?.isCreate;
  };

  const isDelete = (code: string) => {
    return me?.permissions?.[code]?.isDelete;
  };

  const isAccess = (code: string) => {
    return me?.permissions?.[code]?.hasAccess;
  };

  return {
    role,
    setRole,
    isLoading,
    check: {
      isEdit,
      isView,
      isCreate,
      isDelete,
      isAccess,
    },
  };
};

export enum PermissionCode {
  IS_WRITE = 'IS_WRITE',
  IS_VIEW = 'IS_VIEW',

  IS_CREATE = 'IS_CREATE',
  IS_DELETE = 'IS_DELETE',
  IS_ACCESS = 'IS_ACCESS',

  REPORT = 'REPORT',
  VALUATION = 'VALUATION',
  BRANCH = 'BRANCH',
  USER = 'USER',
  USER_STATUS_CHANGE = 'USER_STATUS_CHANGE',
  CAR_BRAND = 'CAR_BRAND',
  CAR_MODEL = 'CAR_MODEL',
  OPTION = 'OPTION',
  OPTION_UPLOAD = 'OPTION_UPLOAD',
  ROLE = 'ROLE',
  APPRAISER = 'APPRAISER',
  BRANCH_DIRECTOR = 'BRANCH_DIRECTOR',
  SETTINGS_NON_COLLATERAL_VEHICLE = 'SETTINGS_NON_COLLATERAL_VEHICLE',
  VALUATION_FINALIZE_CONFIRM = 'VALUATION_FINALIZE_CONFIRM',
  VALUATION_PDF = 'VALUATION_PDF'
}
